var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { CarouselSSRWrapper } from "../carousel";
import { Button } from "../button";
import { Icon } from "../icon";
// styles
import { CarouselWrapper, CustomButtonWrapper, } from "./heroimagecarousel.styles";
import { StyledScrollIndicatorWrapper, IconText } from "./heroimage.styles";
export function HeroImageCarousel(_a) {
    var { children, items, autoslide = true, loop = true } = _a, previewProps = __rest(_a, ["children", "items", "autoslide", "loop"]);
    const [activeColor, setActiveColor] = useState();
    const iconTextRef = useRef(null);
    const [indicatorWidth, setIndicatorWidth] = useState();
    useEffect(() => {
        if (iconTextRef.current) {
            setIndicatorWidth(iconTextRef.current.clientWidth);
        }
    }, [iconTextRef.current]);
    function onCarouselChange(slideIndex) {
        setActiveColor(items[slideIndex].color);
        iconTextRef.current.textContent = items[slideIndex].scrollIndicatorText;
    }
    return (_jsxs(CarouselWrapper, { children: [_jsx(CarouselSSRWrapper, Object.assign({ autoSnap: true, autoSliding: autoslide, loop: loop, slidingInterval: 6, responsiveLayout: {
                    small: { slides: 1, slidesToMove: 1 },
                    medium: { slides: 1, slidesToMove: 1 },
                    large: { slides: 1, slidesToMove: 1 },
                }, onChange: onCarouselChange, slideMargin: 0, nextEl: ".carousel-right-button", prevEl: ".carousel-left-button" }, { children: children })), _jsxs(CustomButtonWrapper, Object.assign({ color: activeColor }, { children: [_jsx(Button, { stylingType: "secondary", rounded: true, symbol: "ChevronLeft", isIcon: true, className: "carousel-left-button", "data-testid": "heroimage-carousel-button-left" }), _jsx(Button, { stylingType: "secondary", rounded: true, symbol: "ChevronRight", isIcon: true, className: "carousel-right-button", "data-testid": "heroimage-carousel-button-right" })] })), _jsxs(StyledScrollIndicatorWrapper, Object.assign({ animation: false }, { children: [_jsx(IconText, { ref: iconTextRef, color: activeColor, animation: false, alignment: indicatorWidth > 72 ? "flex-end" : "center" }), _jsx(Icon, { symbol: "DoubleChevronDown", color: activeColor })] }))] }));
}
